<template>
    <section class="assessmentSection questionsSection additionalEquipmentSection">
        <div class="questionsTopBG"></div>
        <div class="pageContent">
            <div class="pageTitle">What do you want to do?</div>

            <router-link class="addEquipmentPanelLink"
                         to="/assessment/doors">
                <true-panel class="addEquipment-panel">
                    I want to protect an exterior door <img src="/img/door-opened.png"
                         alt="Door Opened">
                </true-panel>
            </router-link>

            <router-link class="addEquipmentPanelLink"
                         to="/assessment/areas-of-concern">
                <true-panel class="addEquipment-panel">
                    I want to protect a room/windows <img src="/img/window-opened.png"
                         alt="Window Opened">
                </true-panel>
            </router-link>

            <router-link class="addEquipmentPanelLink"
                         to="/assessment/environmental">
                <true-panel class="addEquipment-panel">
                    I want to add environmental protection <img src="/img/droplet-fire.png"
                         alt="Fire Droplet"> <img src="/img/droplet-water.png"
                         alt="Water Droplet">
                </true-panel>
            </router-link>

            <router-link class="addEquipmentPanelLink"
                         to="/assessment/automation">
                <true-panel class="addEquipment-panel">
                    I want to add cameras <img class="inline"
                         src="/img/camera.png"
                         alt="Camera"> and/or
                         <br> Home Automation <img class="inline"
                         src="/img/two-gears.png"
                         alt="Two Gears"> to my system
                </true-panel>
            </router-link>


        </div>

    </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    computed: {
        ...mapState([])
    },
    methods: {
        ...mapActions([])
    }
}
</script>

<style lang="css"></style>
